import { Component, EventEmitter, Input, Output, PipeTransform } from '@angular/core';
import { HtmlBase, PropertyData, QueovalItem, QueovalItemModel } from '../../../../models';
import { HttpService, CoreService } from '../../../../services';
import { BaseAddOnComponent } from '../base-addon.component';
import { b64UrlEncodeUnicode } from '../../../../utilities';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Pipe } from '@angular/core';


@Pipe({
  name: 'calculHeight'
})
export class CalculHeightPipe implements PipeTransform {

  constructor(private sanitazer: DomSanitizer) { }
  /**
   *  affiche les differents éléments et listes dans une liste (sous forme de blocs) afin de pouvoir être rendus dans le cdkVirtualFor
   * @param selectedList éléménets sélectionnés
   * @param elementList liste de tous les éléments
   * @param inputValue valeur saisie pour le filtre
   * @param nullable
   * @param multipleSelection
   * @param labelPropName
   * @param identPropName
   */
  transform(list: Array<any>): SafeStyle {
    if (list && list.length < 7) {
      return this.sanitazer.bypassSecurityTrustStyle(list.length * 25 + 'px');
    }
    return this.sanitazer.bypassSecurityTrustStyle('150px');
  }

}



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-codepostal',
  templateUrl: './codepostal.component.html',
  styleUrls: ['./codepostal.component.css', '../../dynamictag.component.css']
})

export class CodePostalComponent extends BaseAddOnComponent {

  showListCP: boolean = false;
  listCP: Array<QueovalItem> = [];
  showListCity: boolean = false;
  listCity: Array<QueovalItem> = [];

  @Input('input') input: PropertyData;
  @Output() navig: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(false);

  constructor(private httpservice: HttpService, private indParam: CoreService) { super(); }

  /** @description input text keyup event: for returning search result for CP
  * @return
  */
  searchCP(): void {
    // On montre la liste des codes postaux à partir de 2 caractères !
    if (!this.input.MainElementList[0].Value || this.input.MainElementList[0].Value === '' || this.input.MainElementList[0].Value.length < 2) {
      this.showListCP = false;
      return;
    }

    function makeDelay(ms: number): any {
      let timer: any = 0;
      return (callback: any): any => {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    }

    const delay: any = makeDelay(500);
    delay(() => {
      if (this.input.MainElementList[0] && this.input.MainElementList[0].Value && this.input.MainElementList[0].Value !== '') {
        const sendData: string = b64UrlEncodeUnicode(`${this.input.MainElementList[0].Value}|CP`);
        this.httpservice.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/SEARCH/${sendData}`)
          .subscribe((result: QueovalItemModel) => {
            if (!result.HasError) {
              this.listCP = result.queovalItemList;
              this.showListCP = this.listCP.length > 0;
              // Si la requête a mis trop de temps et qu'on a perdu le focus -> on ferme la liste des résultats
              if (document.activeElement !== document.getElementById(this.input.MainElementList[0].ID)) {
                this.showListCP = false;
              }
            }
          });
      }
    });
  }

  /** @description input text keyup event: for returning search result for City
  * @return
  */
  searchCity(): void {
    // On montre la liste des codes postaux à partir de 1 caractère
    if (!this.input.MainElementList[1].Value || this.input.MainElementList[1].Value === '') {
      this.showListCity = false;
      return;
    }

    function makeDelay(ms: number): any {
      let timer: any = 0;
      return (callback: any): any => {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    }

    const delay: any = makeDelay(500);
    delay(() => {
      if (this.input.MainElementList[1] && this.input.MainElementList[1].Value && this.input.MainElementList[1].Value !== '') {
        const sendData: string = b64UrlEncodeUnicode(`${this.input.MainElementList[1].Value}|VILLE`);
        this.httpservice.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/SEARCH/${sendData}`)
          .subscribe((result: QueovalItemModel) => {
            if (!result.HasError) {
              this.listCity = result.queovalItemList;
              this.showListCity = this.listCity.length > 0;
              // Si la requête a mis trop de temps et qu'on a perdu le focus -> on ferme la liste des résultats
              if (document.activeElement !== document.getElementById(this.input.MainElementList[1].ID)) {
                this.showListCity = false;
              }
            }
          });
      }
    });
  }

  /** @description list result click element event
   * @param itemCP the selected list element CP
   * @return
   */
  selectCP(codePostal: string): void {
    this.showListCP = false;
    if (codePostal && codePostal !== '') {
      this.input.MainElementList[0].Value = codePostal;
      // Action au click sur le code postal -> récupération de la liste des villes associées si cette dernière n'est pas renseignée
      if (!this.input.MainElementList[1] || !this.input.MainElementList[1].Value || this.input.MainElementList[1].Value === '') {
        const sendData: string = b64UrlEncodeUnicode(`${codePostal}|VILLEFROMCP`);
        this.httpservice.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/SEARCH/${sendData}`)
          .subscribe((result: QueovalItemModel) => {
            if (!result.HasError) {
              this.listCity = result.queovalItemList;
              this.showListCity = this.listCity.length > 1;
              // S'il n'y a qu'une ville associé au code postal -> on la met par défaut (sans liste)
              if (this.listCity.length === 1) {
                this.input.MainElementList[1].Value = this.listCity[0].Text;
              }
            }
          });
      }
    }

  }

  /** @description list result click element event
   * @param itemCity the selected list element City
   * @return
   */
  selectCity(city: string): void {
    this.showListCity = false;
    if (city && city !== '') {
      this.input.MainElementList[1].Value = city;
      // Action au click sur la ville -> récupération de la liste des codes postaux associés s'il est vide
      if (!this.input.MainElementList[0] || !this.input.MainElementList[0].Value || this.input.MainElementList[0].Value === '') {
        const sendData: string = b64UrlEncodeUnicode(`${city}|CPFROMVILLE`);
        this.httpservice.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/SEARCH/${sendData}`)
          .subscribe((result: QueovalItemModel) => {
            if (!result.HasError) {
              this.listCP = result.queovalItemList;
              this.showListCP = this.listCP.length > 1;
              // S'il n'y a qu'un code postal associé à la ville (cas courant sauf homonyme) -> on le met par défaut (sans liste)
              if (this.listCP.length === 1) {
                this.input.MainElementList[0].Value = this.listCP[0].Text;
              }
            }
          });
      }
    }
  }

  public onClickButton(button: HtmlBase): void {
    switch (button.TypeModal.toUpperCase()) {
      default:
        this.navig.emit(button);
    }
  }
}
